import { gql } from 'apollo-angular';

// Keep in sync with the backend GraphQL schema (aur-backend/src/graphql/schema.gql).

export const REFRESH_ADMIN_TOKEN = gql`
  mutation RefreshAdminToken($input: RefreshTokenInputDto!) {
    refreshAdminToken(input: $input) {
      accessToken
      accessTokenExpiresIn
      refreshToken
      refreshTokenExpiresIn
    }
  }
`;

export const LOGOUT_ADMIN = gql`
  mutation LogoutAdmin($input: LogoutInputDto!) {
    logoutAdmin(input: $input)
  }
`;

export const ADMIN_ME = gql`
  query AdminMe {
    adminMe {
      adminId
      email
      displayName
      roles
      permissions
    }
  }
`;
